export class AuthConstants {
  public static readonly passwordMinLength: number = 12;
  public static readonly passwordMaxLength: number = 255;
}
